import { Map } from 'immutable';

import * as types from './Types.js';
import { buildUrl } from './UrlFilter';

const EMPTY_PAGE = Map({});

export function findEmendaEmpenhos(filtros, page = EMPTY_PAGE) {
  const url = buildUrl(
    '/api/emendas-parlamentares/contabilidade/empenhos/movimentacoes',
    filtros,
    page
  );
  return ({ fetch }) => ({
    type: types.CONSULTA_EMENDA_EMPENHOS,
    payload: { promise: fetch(url) }
  });
}

export function findEmendaEmpenhosTotal(filtros) {
  const url = buildUrl(
    '/api/emendas-parlamentares/contabilidade/empenhos/movimentacoes/totalizadores',
    filtros
  );
  return ({ fetch }) => ({
    type: types.CONSULTA_EMENDA_EMPENHOS_TOTAL,
    payload: { promise: fetch(url) }
  });
}

export function findTiposTransferencias() {
  return ({ fetch }) => ({
    type: types.TIPO_TRANSFERENCIA_EMPENHOS,
    payload: {
      promise: fetch(
        '/api/emendas-parlamentares/contabilidade/tipos-transferencias'
      )
    }
  });
}

export function resetConsulta() {
  return { type: types.RESET_CONSULTA_EMENDA_EMPENHOS };
}
